const msg_codeCN = {
    MSG_CODE_001:'用户名或密码错误',
    MSG_CODE_002:'token已失效',
    MSG_CODE_003:'token非法',
    MSG_CODE_004:'授权失败',
    MSG_CODE_005:'请输入账号',
    MSG_CODE_006:'账号不存在',
    MSG_CODE_007:'密码找回',
    MSG_CODE_008:'帐号不能为空',
    MSG_CODE_009:'当前账户已存在',
    MSG_CODE_010:'注册验证码',
    MSG_CODE_011:'发送成功！',
    MSG_CODE_012:'注册成功！',
    MSG_CODE_013:'注册失败！',
    MSG_CODE_014:'访问错误',
    MSG_CODE_015:'密码不能为空',
    MSG_CODE_016:'两次密码不一致',
    MSG_CODE_017:'修改时间已过期',
    MSG_CODE_018:'修改密码失败',
    MSG_CODE_019:'没有更多了',
    MSG_CODE_020:'用户已被停用',
    MSG_CODE_021:'帐号被停止使用',
    MSG_CODE_022:'没有查询到社交信息',
    MSG_CODE_023:'已发送邀请',
    MSG_CODE_024:'请先选中数据',
    MSG_CODE_025:'导出文件格式错误',
    MSG_CODE_026:'未知导出类型',
    MSG_CODE_027:'没有找到数据',
    MSG_CODE_028:'没有查询到联系人信息，此次查看不扣联系人额度',
    MSG_CODE_029:'新密码不能和旧密码一样',
    MSG_CODE_030:'账户不存在',
}
export default msg_codeCN


// WEBPACK FOOTER //
// ./src/lan/cn/cn_msg_code.js